import type { LucideIcon } from "lucide-react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface Props {
  icon: LucideIcon;
  title: string;
  count: number;
  testId: string;
  onAdd?: () => void;
  disabledTooltip?: string;
}

export function AssetSectionHeader({ icon: Icon, title, count, testId, onAdd, disabledTooltip }: Props) {
  const button = (
    <Button
      variant="outline"
      size="sm"
      className="rounded-full gap-1.5 cursor-pointer"
      disabled={!onAdd}
      aria-disabled={!onAdd}
      data-testid={`${testId}-add`}
      onClick={onAdd}
    >
      <Plus className="w-4 h-4" /> Add
    </Button>
  );

  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-border">
      <div className="flex items-center gap-2">
        <Icon className="w-5 h-5 text-foreground" aria-hidden="true" />
        <h3 className="text-base font-semibold">{title}</h3>
      </div>
      <div className="flex items-center gap-3">
        <span
          className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-muted text-xs font-medium text-muted-foreground"
          data-testid={`${testId}-count`}
        >
          {count}
        </span>
        {onAdd ? (
          button
        ) : (
          <Tooltip>
            <TooltipTrigger asChild>
              <span tabIndex={0} className="inline-block">
                {button}
              </span>
            </TooltipTrigger>
            <TooltipContent>{disabledTooltip ?? "Coming soon"}</TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
